var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/menu",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.9767442,17 C22.5418728,17 23,17.4477153 23,18 C23,18.5522847 22.5418728,19 21.9767442,19 L21.9767442,19 L2.02325581,19 C1.45812723,19 1,18.5522847 1,18 C1,17.4477153 1.45812723,17 2.02325581,17 L2.02325581,17 Z M21.9767442,11 C22.5418728,11 23,11.4477153 23,12 C23,12.5522847 22.5418728,13 21.9767442,13 L21.9767442,13 L2.02325581,13 C1.45812723,13 1,12.5522847 1,12 C1,11.4477153 1.45812723,11 2.02325581,11 L2.02325581,11 Z M21.9767442,5 C22.5418728,5 23,5.44771525 23,6 C23,6.55228475 22.5418728,7 21.9767442,7 L21.9767442,7 L2.02325581,7 C1.45812723,7 1,6.55228475 1,6 C1,5.44771525 1.45812723,5 2.02325581,5 L2.02325581,5 Z",
  id: "\\uD83C\\uDFA8-icon-color",
  fill: "#32373C"
}))));
export { SvgMenu as ReactComponent };
export default __webpack_public_path__ + "images/menu.svg";